// /components/FormesCanvas.js
import { useEffect, useRef, useCallback } from "react";

const couleurEnAnglais = {
  rouge: "red",
  bleu: "blue",
  vert: "green",
  jaune: "yellow",
  noir: "black",
  violet: "purple",
};

function traduireCouleur(couleur) {
  if (!couleur) return "black";
  return couleurEnAnglais[couleur.toLowerCase()] || "black";
}

function FormesCanvas({
  formes,
  editable = false,
  onSelectForme = () => {},
  canvasRef,
  onMouseMove,
  onMouseUp,
  width = 1000,
  height = 500,
}) {
  const internalRef = useRef(null);
  const ref = canvasRef || internalRef;
  const grilleSize = 50;

  const dessinerGrille = useCallback((ctx, width, height) => {
    ctx.strokeStyle = "#ccc";
    ctx.lineWidth = 0.5;
    for (let x = 0; x <= width; x += grilleSize) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
      ctx.stroke();
    }
    for (let y = 0; y <= height; y += grilleSize) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
    }
  }, [grilleSize]);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    console.log("✅ redraw triggered")
    dessinerGrille(ctx, canvas.width, canvas.height);
    console.log("🎨 Redessine avec :", formes);

    formes.forEach((forme) => {
      if (!forme || !forme.nom) return;
      ctx.fillStyle = traduireCouleur(forme.couleur || "black");
      if (forme.nom.toLowerCase().includes("rectangle")) {
        ctx.fillRect(forme.posX, forme.posY, forme.largeur, forme.longueur);
      } else if (forme.nom.toLowerCase() === "rond") {
        ctx.beginPath();
        ctx.arc(forme.posX, forme.posY, forme.rayon, 0, Math.PI * 2);
        ctx.fill();
      } else if (forme.nom.toLowerCase().includes("triangle")) {
        ctx.beginPath();
        ctx.moveTo(forme.posX, forme.posY);
        ctx.lineTo(forme.posX + forme.base, forme.posY);
        ctx.lineTo(forme.posX, forme.posY - forme.hauteur);
        ctx.closePath();
        ctx.fill();
      } else if (forme.nom.toLowerCase() === "hexagone") {
        const cote = forme.cotes || 10;
        const posX = forme.posX || 0;
        const posY = forme.posY || 0;
        ctx.beginPath();
        for (let i = 0; i < 6; i++) {
          const angle = (Math.PI / 3) * i;
          const x = posX + Math.cos(angle) * cote;
          const y = posY + Math.sin(angle) * cote;
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.closePath();
        ctx.fill();
      }
    });
  }, [dessinerGrille, formes]);

  return (
    <div>
      <canvas
        key={formes.map(f => `${f.uniqueId}-${f.posX}-${f.posY}`).join("-")}
        ref={ref}
        width={width}
        height={height}
        onClick={onSelectForme}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
      />
    </div>
  );
}

export default FormesCanvas;
